(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        /* Der Liefer-Kern laedt asynchron (Modul): sonst auf 'pp:delivery-ready' warten */
        this.abortController = new AbortController();
        if (window.ppDelivery) this.start();
        else document.addEventListener('pp:delivery-ready', () => this.start(), { once: true, signal: this.abortController.signal });
      }

      start() {
        if (!this.isConnected || !window.ppDelivery) return;
        clearInterval(this.timer);
        const d = this.dataset;
        this.config = window.ppDelivery.readConfig(this);
        this.countdownTemplate = d.tplCountdown || '';
        this.slots = {
          date: this.querySelector('[data-slot="date"]'),
          countdown: this.querySelector('[data-slot="countdown"]'),
          occasion: this.querySelector('[data-slot="occasion"]'),
        };

        this.update = this.update.bind(this);
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };

        this.update();
        this.timer = setInterval(this.update, 30000);
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      /* Ersetzt {countdown} und {shipday} durch fett gesetzte Werte, ohne HTML aus dem Text zu parsen */
      fillTemplate(element, template, values) {
        const parts = template.split(/(\{countdown\}|\{shipday\})/);
        element.replaceChildren(
          ...parts.map((part) => {
            const key = part.slice(1, -1);
            if (!(part.startsWith('{') && key in values)) return part;
            const strong = document.createElement('strong');
            strong.textContent = values[key];
            return strong;
          })
        );
      }

      update() {
        const core = window.ppDelivery;
        const result = core.compute(this.config);

        this.slots.date.textContent = core.formatRange(result.earliest, result.latest);

        if (this.countdownTemplate) {
          this.fillTemplate(this.slots.countdown, this.countdownTemplate, {
            countdown: core.formatCountdown(result.minutesToCutoff ?? result.minutesLeft),
            shipday: core.formatShipDay ? core.formatShipDay(result.shipDate, result.today) : '',
          });
          this.slots.countdown.hidden = false;
        } else {
          this.slots.countdown.hidden = true;
        }

        if (this.slots.occasion) {
          const hit = core.activeOccasion ? core.activeOccasion(result) : null;
          const text = this.slots.occasion.querySelector('[data-occasion-text]');
          if (hit && text) text.textContent = (text.dataset.tpl || 'Kommt rechtzeitig zu {occasion} an').replace('{occasion}', hit.label);
          this.slots.occasion.hidden = !hit;
        }

        this.dataset.state = result.beforeCutoff ? 'before-cutoff' : 'after-cutoff';
      }
    }

    customElements.define('delivery-estimate', DeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-product-highlights"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-highlights')) {
    /* Groessenabhaengige Zeilen ({groesse}, {masse}) beim Variantenwechsel aktualisieren.
       Horizon (variant-picker.js) feuert "shopify:product:select" auf dem variant-picker; das Event bubbelt
       bis zur Section, das Promise liefert das neu gerenderte Section-HTML. */
    class PpHighlights extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (this.section) this.section.addEventListener('shopify:product:select', this.handleProductSelect);
      }

      disconnectedCallback() {
        if (this.section) this.section.removeEventListener('shopify:product:select', this.handleProductSelect);
      }

      handleProductSelect = (event) => {
        const source = event.target instanceof Element ? event.target : null;
        /* Produktkarten (Swatches) und Dialoge innerhalb der Section ignorieren */
        if (!source || source.closest('product-card, dialog')) return;
        if (!event.promise || typeof event.promise.then !== 'function') return;

        event.promise
          .then((result) => {
            const html = result && result.detail && result.detail.html;
            if (!html || typeof html.querySelector !== 'function') return;
            const fresh = html.querySelector(`pp-highlights[data-block-id="${this.dataset.blockId}"]`);
            if (fresh && fresh.innerHTML !== this.innerHTML) this.innerHTML = fresh.innerHTML;
          })
          .catch((error) => {
            if (!error || error.name !== 'AbortError') console.warn('[pp-highlights]', error);
          });
      };
    }

    customElements.define('pp-highlights', PpHighlights);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-gpsr')) {
    class PpGpsr extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('script[type="application/json"]');
        const output = this.querySelector('[data-gpsr-output]');
        if (!source || !output || output.childElementCount > 0) return;

        let data = null;
        try {
          data = JSON.parse(source.textContent);
        } catch (error) {
          return;
        }

        const groups = [
          ['SafetyInformation', this.dataset.safetyLabel],
          ['WarningInformation', this.dataset.warningLabel],
        ];

        for (const [key, label] of groups) {
          const raw = data && typeof data[key] === 'string' ? data[key] : '';
          const lines = raw
            .split(/<br\s*\/?>/i)
            .map((line) => line.replace(/^\s*-\s*/, '').trim())
            .filter(Boolean);
          if (lines.length === 0) continue;

          const heading = document.createElement('p');
          heading.className = 'pp-info__subhead';
          heading.textContent = label;

          const list = document.createElement('ul');
          for (const line of lines) {
            const item = document.createElement('li');
            item.textContent = line;
            list.append(item);
          }

          output.append(heading, list);
        }
      }
    }

    customElements.define('pp-gpsr', PpGpsr);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-sticky-atc')) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    class PpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        const scope = this.section || document;
        this.target = this.findTarget(scope);
        this.button = this.querySelector('.pp-satc__btn');
        this.price = this.querySelector('[data-price]');
        if (!this.target || !this.button || !('IntersectionObserver' in window)) return;

        this.button.addEventListener('click', this.handleClick);
        /* Horizon (variant-picker.js) feuert "shopify:product:select" auf dem variant-picker, das Event
           bubbelt bis zur Section. Nur die eigene Section abhoeren, nicht document: so bleiben
           Quick-Add-Dialog und Produktempfehlungen aussen vor. */
        if (this.section) this.section.addEventListener('shopify:product:select', this.handleProductSelect);

        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.button) this.button.removeEventListener('click', this.handleClick);
        if (this.section) this.section.removeEventListener('shopify:product:select', this.handleProductSelect);
      }

      findTarget(scope) {
        return (
          scope.querySelector('.product-form-buttons button[name="add"]') ||
          scope.querySelector('.product-form-buttons [ref="addToCartButton"]') ||
          scope.querySelector('.product-form-buttons')
        );
      }

      handleClick = () => {
        /* Nach einem Morph (z. B. Combined Listing) kann der gemerkte Button ausgehaengt sein */
        if (!this.target.isConnected) {
          const fresh = this.findTarget(this.section || document);
          if (fresh) {
            this.observer.unobserve(this.target);
            this.target = fresh;
            this.observer.observe(this.target);
          }
        }
        const canAdd = this.dataset.mode === 'add' && this.target.tagName === 'BUTTON' && !this.target.disabled;
        if (canAdd) {
          this.target.click();
        } else {
          this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

      handleProductSelect = (event) => {
        const source = event.target instanceof Element ? event.target : null;
        /* Produktkarten (Swatches) und Dialoge innerhalb der Section ignorieren */
        if (!source || source.closest('product-card, dialog')) return;
        if (!event.promise || typeof event.promise.then !== 'function') return;

        event.promise
          .then((result) => {
            const detail = result && result.detail;
            if (!detail) return;
            if (detail.newProduct && detail.newProduct.id) {
              this.dataset.productId = String(detail.newProduct.id);
            } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
              return;
            }
            this.applyVariant(detail);
          })
          .catch((error) => {
            if (!error || error.name !== 'AbortError') console.warn('[pp-sticky-atc]', error);
          });
      };

      applyVariant(detail) {
        const variant = detail.resource;
        const fresh =
          detail.html && typeof detail.html.querySelector === 'function'
            ? detail.html.querySelector(`pp-sticky-atc[data-block-id="${this.dataset.blockId}"]`)
            : null;

        let available = Boolean(variant && variant.available);
        if (fresh) {
          /* Server-gerendert: Waehrungsformat und Texte exakt wie beim Seitenaufruf */
          const freshPrice = fresh.querySelector('[data-price]');
          if (freshPrice && this.price) this.price.innerHTML = freshPrice.innerHTML;
          if (fresh.dataset.available) available = fresh.dataset.available === 'true' && Boolean(variant);
        } else if (variant && typeof variant.price === 'number' && this.price) {
          this.price.textContent = priceFormatter.format(variant.price / 100);
        }

        this.dataset.available = String(available);
        if (this.dataset.mode === 'add' && this.button) {
          this.button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        }
      }
    }

    customElements.define('pp-sticky-atc', PpStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
